import { render, staticRenderFns } from "./doctorDataAnalysis.vue?vue&type=template&id=42f78116&scoped=true"
import script from "./doctorDataAnalysis.vue?vue&type=script&lang=js"
export * from "./doctorDataAnalysis.vue?vue&type=script&lang=js"
import style0 from "./doctorDataAnalysis.vue?vue&type=style&index=0&id=42f78116&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f78116",
  null
  
)

export default component.exports